import React, { Component } from 'react';
import { DropdownButton } from "react-bootstrap";
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { connect } from 'react-redux';
import BootstrapTable from 'react-bootstrap-table-next';
import {
    dateFormatter,
    daysToPayFormatter,
    documentNumberFormatter,
    documentNumberFormatterTextSecondary,
    dueFormatter, formatDaysInArrears,
    openFormatter,
    paidFormatter,
    pdfFormatter,
    referenceFormatter,
    statusFormatter,
    totalFormatter
} from '../../common/invoiceHelpers';
import { getSelectedInvoiceKeys, getSelectedPrimaryAccount, getSelectedSecondaryAccount } from './Selectors';
import {
    addInvoiceToSelected,
    removeInvoiceFromSelected
} from '../../actions/InvoiceActions';
import * as appConstants from '../../constants/ApplicationConstants';
import { PAYER_COMPARE } from '../../constants/ApplicationConstants';
import _ from 'lodash';
import { ACCOUNT_PAYER_ALL } from "../../constants/ApplicationConstants";
import { canMakePayment } from "../../PermissionSelectors";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import { updateState } from "../../actions/CommonActions";
import * as types from "../../constants/ActionTypes";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import {
    DownloadPdfZipButton,
} from "./DownloadPdfZipButton";
import {
    getInvoiceQuery,
} from './Selectors';

// Inject custom styles directly into the component
const styles = `
  /* Target the button inside the custom dropdown */
.custom-dropdown-button button {
  color: #fff !important; /* Force text color to white */
  background-color: #c80000 !important; /* Default red background */
  border-color: #c80000 !important; /* Default red border */
}

/* Hover styles for the button */
.custom-dropdown-button button:hover {
  color: #fff !important; /* White text on hover */
  background-color: #a20000 !important; /* Darker red background */
  border-color: #950000 !important; /* Darker red border */
}
`;

// Inject the styles into the document head
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);
export function isCredit(invoice) {
    return (invoice.open_amount && invoice.open_amount < 0);
}

function shouldSortCredit(rowA, rowB) {
    let isACredit = isCredit(rowA);
    let isBCredit = isCredit(rowB);

    return isACredit || isBCredit;
}

function sortCredit(a, b, rowA, rowB, order) {
    let isACredit = isCredit(rowA);
    let isBCredit = isCredit(rowB);

    if (isACredit && isBCredit) {
        return sortStringDate(rowA.document_date, rowB.document_date, order);
    } else if (isACredit && !isBCredit) {
        return 1;
    } else if (!isACredit && isBCredit) {
        return -1;
    }
}

function sortStringNumber(a, b, order) {
    if (order === 'asc') {
        if (parseFloat(a) < parseFloat(b)) {
            return -1;
        } else if (parseFloat(a) > parseFloat(b)) {
            return 1;
        } else {
            return 0;
        }
    } else {
        if (parseFloat(a) > parseFloat(b)) {
            return -1;
        } else if (parseFloat(a) < parseFloat(b)) {
            return 1;
        } else {
            return 0;
        }
    }
}

function sortStringDate(a, b, order) {
    let aDate = moment(a);
    let bDate = moment(b);
    if (order === 'desc') {
        let diff = aDate.diff(bDate, 'days');
        return diff;
    } else {
        let diff = bDate.diff(aDate, 'days');
        return diff;
    }
}

function renderCaret(order, column) {
    if (order === "asc") {
        return <FontAwesomeIcon icon={"caret-up"} className={"ml-1"} size={"sm"} />;
    }
    if (order === "desc") {
        return <FontAwesomeIcon icon={faCaretDown} className={"ml-1"} size={"sm"} />;
    }
    return null;
}

export class InvoiceList extends Component {
    constructor(props) {
        super(props);
        this.customMultiSelect = this.customMultiSelect.bind(this);
        this.onRowSelect = this.onRowSelect.bind(this);
        this.mapSoldTo = this.mapSoldTo.bind(this);
        this.onSelectAll = this.onSelectAll.bind(this);
        this.clickSelectAll = this.clickSelectAll.bind(this);
        this.clickDeselectAll = this.clickDeselectAll.bind(this);
        this.isNotSelectable = this.isNotSelectable.bind(this);
        this.filterFilteredInvoices = this.filterFilteredInvoices.bind(this);
    }

    mapSoldTo(cell) {
        let custOption = '';
        if (this.props.accountType === appConstants.SOLD_TO_COMPARE) {
            custOption = this.props.selectedPrimaryAccount.Name;
        } else {
            for (let l = 0; l < this.props.secondaryAccounts.length; l += 1) {
                const customer = this.props.secondaryAccounts[l];
                if (cell === customer.PrimaryAcct) {
                    custOption = customer.Name;
                    break;
                }
            }
        }
        if (cell) {
            return (<span data-toggle="tooltip" className={"text-secondary"} title={custOption}><small>{cell}</small></span>);
        }
    }

    onRowSelect(row, isSelected) {
        if (isSelected) {
            this.props.dispatch(addInvoiceToSelected(row));
        } else {
            this.props.dispatch(removeInvoiceFromSelected(row));
        }
    }

    renderHeaderCheckbox({ mode, checked, indeterminate }) {
        let checkbox = (<div className="checkbox-personalized d-inline-block">
            <div>
                <input
                    type={mode}
                    checked={checked}
                    readOnly={true}
                />
                <label htmlFor={`checkbox`}>
                    <div className="check header-check" />
                </label>
            </div>
        </div>);
        return (<div className="column-header text-center">
            <span >Pay</span></div>);
    }

    customMultiSelect = props => {
        const { mode, checked, disabled } = props;
        return (
            <div className="checkbox-personalized">
                {!disabled ? (
                    <div>
                        <input
                            type={mode}
                            checked={checked}
                            disabled={disabled}
                            readOnly={true}
                        />
                        <label htmlFor={`checkbox`}>
                            <div className="check" />
                        </label>
                    </div>
                ) : (
                    <div />
                )}
            </div>
        );
    };

    onSelectAll(isSelect, rows, e) {
        rows.forEach(row => {
            if (isSelect) {
                this.props.dispatch(addInvoiceToSelected(row));
            } else {
                this.props.dispatch(removeInvoiceFromSelected(row));
            }
        });
    }

    clickSelectAll(e) {
        this.props.invoices.filter((invoice) => !this.isNotSelectable(invoice))
            .filter(this.filterFilteredInvoices)
            .forEach(invoice => {
                this.props.dispatch(addInvoiceToSelected(invoice));
            });
    }

    filterFilteredInvoices(invoice) {
        if (this.props.accountType === PAYER_COMPARE || this.props.accountType === ACCOUNT_PAYER_ALL) {
            return this.props.selectedSoldTos.indexOf(_.trimStart(invoice.soldto_number, '0')) !== -1;
        }
        return true;

    }

    isPdfFilenotExists(invoicesWithKeys): boolean {
        const PDFFileIds: string[] = [];
        if (sessionStorage.getItem("invoicesWithKeysData") != null) {
            sessionStorage.removeItem("invoicesWithKeysData");
        }
        var pdfExists = false;
        invoicesWithKeys.forEach((invoice) => {
            if (invoice.pdf_document_available === "X" || invoice.is_customer_mapped === true) {
                pdfExists = true;
                if (invoice.payer_number != null) {
                    let docNumber;

                    if (invoice.finance_document_type.toUpperCase() === "ZY") {
                        docNumber = invoice.reference_number;
                    } else {
                        docNumber = invoice.billing_document_number;
                    }

                    PDFFileIds.push(docNumber, invoice.payer_number, invoice.finance_document_type);
                }
            }
        });
        sessionStorage.setItem("invoicesWithKeysData", JSON.stringify(PDFFileIds));
        return pdfExists;
    }

    clickDeselectAll(e) {
        this.props.invoices.filter((invoice) => !this.isNotSelectable(invoice))
            .filter(this.filterFilteredInvoices)
            .forEach(invoice => {
                this.props.dispatch(removeInvoiceFromSelected(invoice));
            });
    }

    isNotSelectable(invoice) {
        if ((invoice.read_only_flag && invoice.read_only_flag === 'X')) {
            return true;
        }
        return this.props.isSearch;
    }

    render() {
        let hideSelect = this.props.isSearch || !this.props.canMakePayment;
        const selectRowProp = {
            mode: 'checkbox',
            onSelect: this.onRowSelect,
            onSelectAll: this.onSelectAll,
            selected: this.props.selectedInvoicesKeys,
            selectionRenderer: this.customMultiSelect,
            selectionHeaderRenderer: this.renderHeaderCheckbox,
            nonSelectable: this.props.invoices.filter((invoice) => this.isNotSelectable(invoice)).map(invoice => {
                return invoice.billing_document_number + '__' + invoice.document_number_finance;
            }),
            hideSelectColumn: hideSelect,
        };
        const tab = 'table';
        const top = 'Top';

        let invoices = this.props.invoices;
        if (!this.props.isSearch) {
            if (this.props.accountType === PAYER_COMPARE || this.props.accountType === ACCOUNT_PAYER_ALL) {
                invoices = this.props.invoices.filter(this.filterFilteredInvoices);
            }
        }

        const columnConfigs = [
            {
                headerClasses: "column-header",
                dataField: "billing_document_type",
                formatter: statusFormatter,
                text: "Status",
                headerStyle: { width: '65px' },
                headerAlign: "center",
                align: "center",
            },
            {
                headerClasses: "column-header",
                dataField: "reference_number",
                formatter: referenceFormatter,
                text: "Ref #",
                sort: true,
                sortCaret: renderCaret,
                headerStyle: { width: '95px' },
                headerAlign: "center",
                align: "center",
            },
            {
                headerClasses: "column-header",
                dataField: "document_number_finance",
                formatter: documentNumberFormatterTextSecondary,
                text: "Doc #",
                sortCaret: renderCaret,
                headerStyle: { width: '95px' },
                sort: true,
                headerAlign: "center",
                align: "center",
            },
            {
                headerClasses: "column-header",
                dataField: "document_date",
                formatter: dateFormatter,
                text: "Date",
                sort: true,
                sortCaret: renderCaret,
                headerStyle: { width: '65px' },
                headerAlign: "center",
                sortFunc: sortStringDate,
                align: "center",
            },
            {
                headerClasses: "column-header",
                dataField: "total_amount",
                formatter: totalFormatter,
                headerFormatter: (col, colIndex, components) => {
                    return (<span><FormattedMessage id={"invoice_table.total_amount"} />{components.sortElement}</span>)
                },
                text: "Total",
                sort: true,
                sortCaret: renderCaret,
                headerStyle: { width: '80px' },
                headerAlign: "center",
                align: "right",
                sortFunc: sortStringNumber,
            },
            {
                headerClasses: "column-header",
                dataField: "paid_amount",
                formatter: paidFormatter,
                text: "Paid",
                sort: true,
                sortCaret: renderCaret,
                headerStyle: { width: '80px' },
                headerAlign: "center",
                align: "right",
                sortFunc: sortStringNumber,
            },
            {
                headerClasses: "column-header",
                dataField: "open_amount",
                formatter: openFormatter,
                headerFormatter: (col, colIndex, components) => {
                    return (<span><FormattedMessage id={"invoice_table.open_amount"} />{components.sortElement}</span>)
                },
                text: "Open",
                sort: true,
                sortCaret: renderCaret,
                headerStyle: { width: '80px' },
                headerAlign: "center",
                align: "right",
                sortFunc: sortStringNumber,
            },
            {
                headerClasses: "column-header",
                dataField: "due_date",
                formatter: dueFormatter,
                text: "Due",
                sort: true,
                sortCaret: renderCaret,
                headerStyle: { width: '70px' },
                sortFunc: (a, b, order, dataField, rowA, rowB) => {
                    if (shouldSortCredit(rowA, rowB)) {
                        return sortCredit(a, b, rowA, rowB, order);
                    }
                    return sortStringDate(a, b, order);
                },
                headerAlign: "center",
                align: "center",
            },
            {
                headerClasses: "column-header",
                dataField: "days_in_arrears",
                formatter: formatDaysInArrears,
                text: "Days Past Due",
                headerStyle: { width: '100px' },
                headerAlign: "center",
                align: "center",
            },
            {
                headerClasses: "column-header",
                dataField: "is_customer_mapped",
                formatter: pdfFormatter,
                text: "PDF",
                headerStyle: { width: '45px' },
                headerAlign: "center",
                align: "center",
            },
            {
                headerClasses: "column-header",
                dataField: "soldto_number",
                formatter: this.mapSoldTo,
                text: "Location",
                headerStyle: { width: '65px' },
                headerAlign: "center",
                align: "center",
            }
        ];

        // Here we get columns based on what fields are in the config.
        let columns = this.props.tableConfig.columns.filter((config) => {
            return columnConfigs.find(_ => _.dataField === config.key);
        }).map(config => columnConfigs.find(_ => _.dataField === config.key));

        invoices.forEach((_) => _._key = _.billing_document_number + '__' + _.document_number_finance);

        return (
            <React.Fragment>
                <div style={{
                    display: "flex",
                    justifyContent: "flex-end"
                }}>
                    <div style={{ width: "92%" }}>
                        {!hideSelect && <div><a href="#" onClick={this.clickSelectAll}>Select All</a> / <a href="#" onClick={this.clickDeselectAll}>Deselect All</a></div>}
                    </div>
                    <div >
                        {
                            invoices.length === 0 ||
                                this.isPdfFilenotExists(invoices) ? (
                                <DropdownButton
                                        disabled={false}
                                        alignRight
                                        size={"sm"}
                                        title={"Download"}
                                        variant={"light"}
                                        id="dropdown-menu-align-right"
                                        className="custom-dropdown-button" // Apply custom styles

                                >
                                    <DownloadPdfZipButton
                                        invoiceSearchQuery={this.props.invoiceSearchQuery}
                                    />
                                </DropdownButton>
                            ) :
                                ""

                            //(
                            //    <DropdownButton
                            //        alignRight
                            //        size={"sm"}
                            //        title={intl.formatMessage({
                            //            id: "invoice_export.download_label",
                            //        })}
                            //        variant={"light"}
                            //        id="dropdown-menu-align-right"
                            //    >
                            //        {props.isSearch ? (
                            //            <DownloadPdfZipButton
                            //                invoiceSearchQuery={props.invoiceSearchQuery}
                            //            />
                            //        ) : (
                            //            <DownloadPdfZipButtonwithCurrency
                            //                invoiceQueryforPDFandCSVandexcel={
                            //                    props.invoiceQueryforPDFandCSVandexcel
                            //                }
                            //            />
                            //        )}
                            //    </DropdownButton>
                            //)

                        }

                    </div>
                </div>
                {/*<DropdownButton*/}
                {/*    disabled={false }*/}
                {/*    alignRight*/}
                {/*    size={"sm"}*/}
                {/*    title={"Download"}*/}
                {/*    variant={"light"}*/}
                {/*    id="dropdown-menu-align-right"*/}
                {/*>*/}
                {/*    <DownloadPdfZipButton invoiceSearchQuery={this.props.invoiceSearchQuery}*/}
                {/*    />*/}
                {/*</DropdownButton>*/}



                <BootstrapTable
                    data={invoices}
                    selectRow={selectRowProp}
                    ref={tab}
                    headerClass={"cnbs-invoice-header"}
                    classes={'wa-bootstrap-table-container custom-table-header'}
                    scrollTop={top}
                    defaultSorted={[{ dataField: "due_date", order: 'desc' }]}
                    columns={columns}
                    keyField={'_key'}
                    bootstrap4={true}
                >
                </BootstrapTable>
            </React.Fragment>
        );
    }
}

InvoiceList.defaultProps = {
    isSearch: false,
};

export default connect((state, props) => {
    return {
        selectedPrimaryAccount: getSelectedPrimaryAccount(state, props),
        selectedSecondaryAccount: getSelectedSecondaryAccount(state, props),
        invoices: state.default.invoices,
        selectedInvoicesKeys: getSelectedInvoiceKeys(state, props),
        selectedSoldTos: state.user_options.selectedSoldTos,
        secondaryAccounts: state.user_options.secondaryAccounts,
        accountType: state.user_options.accountType,
        canMakePayment: canMakePayment(state, props),
        tableConfig: state.app.config.invoice_table,
        invoiceSearchQuery: getInvoiceQuery(state, props),
    };
})(InvoiceList);

export var InvoiceSearchList = connect((state, props) => {
    return {
        selectedPrimaryAccount: getSelectedPrimaryAccount(state, props),
        selectedSecondaryAccount: getSelectedSecondaryAccount(state, props),
        selectedInvoicesKeys: getSelectedInvoiceKeys(state, props),
        selectedSoldTos: state.user_options.selectedSoldTos,
        secondaryAccounts: state.user_options.secondaryAccounts,
        accountType: state.user_options.accountType,
        canMakePayment: canMakePayment(state, props),
        tableConfig: state.app.config.invoice_table,
        invoiceSearchQuery: state.default.invoiceListRequest,
    };
})(InvoiceList);

